import { useSelector } from "react-redux";
import WasteTrendChart from "../dashboard/WasteTrendChart";
import WasteByCodeChart from "../dashboard/WasteByCodeChart";
import LoadingCodeChart from "../dashboard/LoadingCodeChart";
import BranchCompareChart from "../dashboard/BranchCompareChart";

const Statistics = () => {
  const activeTenantId = useSelector((state) => state.users.data.activeTenantId);
  const activeTenantBlocked = useSelector((state) => state.users.data?.activeTenantBlocked);
  const tenantListLoaded = useSelector((state) => state.users.data?.tenantListLoaded);

  if (activeTenantBlocked || !tenantListLoaded) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: 300 }}>
        <div className="text-center" style={{ color: "#718094" }}>
          <p style={{ fontSize: 16 }}>Subjekt je zablokovaný. Prepnite na iný subjekt v bočnom menu.</p>
        </div>
      </div>
    );
  }

  return (
    <div key={activeTenantId} className="container-fluid py-4 px-0">
      {/* Two stacked columns rather than one stretched row - WasteByCodeChart's card can grow
          tall with many waste codes (up to 10, one legend row each), and forcing every card in
          the same row to match that height would leave dead white space under the shorter ones.
          align-items-start is required, not just the absence of align-items-stretch - Bootstrap's
          .row is display:flex with no explicit align-items, so it still defaults to the CSS
          initial value of "stretch" and the columns keep matching each other's height otherwise. */}
      <div className="row g-4 align-items-start">
        <div className="col-12 col-xl-7 d-flex flex-column gap-4">
          <WasteTrendChart />
          <LoadingCodeChart />
        </div>
        <div className="col-12 col-xl-5 d-flex flex-column gap-4">
          <WasteByCodeChart />
          <BranchCompareChart />
        </div>
      </div>
    </div>
  );
};

export default Statistics;
